<template>
    <div id="user_page" class="profiles_page">
        <!-- <section class="hero"></section> -->

        <div class="centered_md">

            
            <ul id="more_profiles">
                
                <li v-for="item in profiles"  :key="'prof' + item.id">
                    <div class="pic"></div>
                    <label v-text="item.name"></label>
                    <router-link :to="'/set_up/' + item.id">עריכת פרופיל</router-link>
                    
                    <a style="text-decoration:underline;" @click="remove_profile(item.id)"  v-if="user.is_active">מחק פרופיל</a>
                    
                </li>
                
                <router-link to="/user/profiles/insert" v-if="user.is_active">
                <li>
                    <div class="pic" id="add_profile"><div class="icon plus" style="font-size:100px">+</div></div>
                    <label>הוסף פרופיל</label>
                    <span>(ניתן להוסיף פרופילים ללא הגבלה)</span>
                </li>
                </router-link>

            </ul>
            

        </div>

    </div>
</template>

<script>

export default {
  data() {
    return {
      profiles: [],
      user: []
    };
  },
  methods: {
      remove_profile(id){
      if (!confirm('אנא אשר את מחיקת הפרופיל')) return false;
      this.api_call({ url: 'remove_profile', data: { id: id }, onComplete: function(){
        document.location = '/user/profiles';

      } } );
    }
    
  },
  created() {
    var self = this;
    // categories 
    this.api_call({ url: 'general', onComplete: function(data){

      self.user = data.data.data.user
      self.profiles = data.data.data.user.profiles;

        self.$emit('loaded');
    } } );

  }
}
</script>